
(() => {

    const PRINT = document.getElementById('print-button');

    if(!PRINT) {
        return;
    }

    PRINT.addEventListener("click", (e) => {
        e.preventDefault();
        window.print();
    });

})()
